export default __webpack_public_path__ + "static/media/testbanner3.f600233b.png";